
document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.exxtra-service-showcase').forEach((section) => {

    const pills = section.querySelectorAll('.service-container-pill');

    const image = section.querySelector('.exxtra-service-showcase__image-element');
    const serviceTitle = section.querySelector('.service-title');

    const stepNumbers = section.querySelectorAll('.exxtra-process-step__number');
    const stepTitles = section.querySelectorAll('.exxtra-process-step__heading');
    const stepDescriptions = section.querySelectorAll('.exxtra-process-step__text');

    const button = section.querySelector('.service-button');

    pills.forEach((pill) => {

      pill.addEventListener('click', () => {

        /* ----------------------------------------
           Active Pill
        ---------------------------------------- */

        pills.forEach((p) => p.classList.remove('is-active'));

        pill.classList.add('is-active');

        /* ----------------------------------------
           Find Service Data
        ---------------------------------------- */

        const block = section.querySelector(
          `[data-service-block="${pill.dataset.service}"]`
        );

        if (!block) return;

        /* ----------------------------------------
           Image
        ---------------------------------------- */

        const imageContainer = section.querySelector('.exxtra-service-showcase__image');

        if (imageContainer && block.dataset.image) {

          imageContainer.innerHTML = `
            <img
              class="exxtra-service-showcase__image-element"
              src="${block.dataset.image}"
              alt="${block.dataset.title}"
              loading="lazy"
            >
          `;

        }

        /* ----------------------------------------
           Service Title
        ---------------------------------------- */

        if (serviceTitle) {

          serviceTitle.textContent = block.dataset.title;

        }

        /* ----------------------------------------
           Steps
        ---------------------------------------- */

        for (let i = 1; i <= 4; i++) {

          if (stepNumbers[i - 1]) {

            stepNumbers[i - 1].textContent =
              block.dataset[`step${i}Number`];

          }

          if (stepTitles[i - 1]) {

            stepTitles[i - 1].textContent =
              block.dataset[`step${i}Title`];

          }

          if (stepDescriptions[i - 1]) {

            stepDescriptions[i - 1].textContent =
              block.dataset[`step${i}Description`];

          }

        }

        /* ----------------------------------------
           Button
        ---------------------------------------- */

        if (button) {

          button.textContent = block.dataset.buttonLabel;

          button.href = block.dataset.buttonLink || '#';

        }

      });

    });

    /* ----------------------------------------
       No automatic pill click on page load.
       Valet Storage content remains in the Liquid
       markup until a visitor clicks a service pill.
    ---------------------------------------- */

  });

});
